const createdAt = (project) => Date.parse(project.created_at) || 0;

const newestFirst = (first, second) => createdAt(second) - createdAt(first);

export function selectHomeProjects(projects) {
  return {
    featured: projects
      .filter((project) => [4, 5].includes(Number(project.rate)))
      .sort(
        (first, second) =>
          Number(second.rate) - Number(first.rate) || newestFirst(first, second)
      )
      .slice(0, 5),
    latest: projects
      .filter((project) => [3, 4, 5].includes(Number(project.rate)))
      .sort(newestFirst)
      .slice(0, 5),
  };
}
